import { formatDate } from 'helpers/date';
import { getEstimatedEPMigrationEndDate } from 'helpers/epMigration';

import { TransactionNode } from '../../Transactions/TransactionList/types';
import locales from './locales';

export const isDirectDebit = (
  transaction: Pick<TransactionNode, 'paymentMethod'>,
) => transaction.paymentMethod === 'DIRECT_DEBIT';

const isPayinTransfer = (
  transaction: Pick<TransactionNode, 'type' | 'paymentMethod'>,
): boolean =>
  ['INSTANT_TRANSFER', 'TRANSFER'].includes(transaction.paymentMethod) &&
  transaction.type === 'payin';

export const isTransactionTypeValidToBeTaggued = (
  transaction: Pick<TransactionNode, 'type' | 'paymentMethod'>,
) => isDirectDebit(transaction) || isPayinTransfer(transaction);

export const getWarningsByTransactionType = ({
  migratedToEPAt,
  transaction,
}: {
  migratedToEPAt?: string | null;
  transaction: Pick<TransactionNode, 'type' | 'paymentMethod'>;
}): string | null => {
  if (!migratedToEPAt) {
    return null;
  }

  if (isPayinTransfer(transaction)) {
    const estimatedMigrationEndDate =
      getEstimatedEPMigrationEndDate(migratedToEPAt);

    return locales.formatString(
      locales.payinTransferWarning,
      formatDate(estimatedMigrationEndDate, 'P'),
    ) as string;
  }

  if (isDirectDebit(transaction)) {
    const estimatedMigrationEndDate =
      getEstimatedEPMigrationEndDate(migratedToEPAt);

    return locales.formatString(
      locales.directDebitWarning,
      formatDate(estimatedMigrationEndDate, 'P'),
    ) as string;
  }

  return null;
};
